import type React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ContactEdit, ContactsList } from '@widgets/contacts';
import { Contacts } from './ui';

export const ContactsPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Contacts />}>
        <Route index element={<ContactsList isSelectedList={true} />} />
        <Route path="add" element={<ContactEdit />} />
        <Route path="edit" element={<ContactEdit />} />
      </Route>
    </Routes>
  );
};
